import backend from './backend';
const endpoint = '/containers';

export default {
    get() {
        return backend.get(endpoint)
    }
}
